import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import './useFinanceTour.css'

const TOUR_SEEN_KEY = 'qm_finance_tour_v1'

function buildSteps() {
  const steps = [
    {
      element: '[data-tour="balance-header"]',
      popover: {
        title: 'Resumo do seu saldo',
        description:
          'Resumo do seu saldo em um só lugar: valores previstos para recebimento, valores aguardando liberação, transferências em andamento e valores já transferidos para sua conta.',
        side: 'bottom',
        align: 'start',
      },
    },
  ]

  // Filtro por evento — só inclui se estiver visível no DOM
  if (document.querySelector('[data-tour="event-filter"]')) {
    steps.push({
      element: '[data-tour="event-filter"]',
      popover: {
        title: 'Filtro por evento',
        description:
          'Tem mais de um evento? Use estas pílulas para visualizar os valores de um evento específico separadamente.',
        side: 'bottom',
        align: 'start',
      },
    })
  }

  steps.push(
    {
      element: '[data-tour="tab-sacar"]',
      popover: {
        title: 'Aba "Saldos"',
        description:
          'Painel principal dos valores por evento. Veja Pix disponível para resgate, valores aguardando liberação, transferências em andamento e repasses de cartão previstos.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="tab-extrato"]',
      popover: {
        title: 'Aba "Extrato"',
        description:
          'Histórico completo de todos os recebimentos, estornos e movimentações. Tudo registrado e rastreável.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="tab-saques"]',
      popover: {
        title: 'Aba "Saques"',
        description:
          'Veja todas as transferências já realizadas para sua conta Pix — com status, data e valor de cada uma.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="tab-avisos"]',
      popover: {
        title: 'Aba "Avisos"',
        description:
          'Quando houver algum problema em uma transferência ou qualquer situação que precise da sua atenção, o aviso aparecerá aqui com orientações sobre o que fazer.',
        side: 'bottom',
        align: 'start',
      },
    },
  )

  return steps
}

export function useFinanceTour() {
  function startTour() {
    const driverObj = driver({
      showProgress: true,
      progressText: '{{current}} de {{total}}',
      nextBtnText: 'Próximo →',
      prevBtnText: '← Anterior',
      doneBtnText: '✓ Entendi',
      popoverClass: 'qm-tour-popover',
      steps: buildSteps(),
      onDestroyed: () => {
        localStorage.setItem(TOUR_SEEN_KEY, '1')
      },
    })
    driverObj.drive()
  }

  function startTourIfFirstVisit() {
    if (!localStorage.getItem(TOUR_SEEN_KEY)) {
      // Pequeno delay para o DOM estabilizar após carregamento dos dados
      setTimeout(startTour, 600)
    }
  }

  return { startTour, startTourIfFirstVisit }
}
